import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-gigabit-whitepaper',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-gigabit-whitepaper.component.scss']
})
export class NestedSidebarGigabitWhitepaperComponent implements OnInit {

  constructor(
    ) { }

    pdf = {
      pdfTitle: 'Tackling the Gigabit Home Networking Challenges',
      pdfimg: './assets/images/sidebar/WP_Cover.webp',
      url: 'gigabitwhitepaper',
      opt: 'BUTTON.DOWNLOAD',
      width: '1275',
      height: '1650'
    };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
    console.log(this.pdf);
    
  }

}
